<script setup>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import AuditTrailSection from 'next/wgpt/AuditTrail/AuditTrailSection.vue';

const route = useRoute();
const { t } = useI18n();

const auditTrailFilters = [
  {
    attributeKey: 'model',
    filterOperator: 'equal_to',
    values: {
      id: 'WgptBotTool',
      name: 'WgptBotTool',
    },
    queryOperator: 'and',
    attributeModel: 'standard',
  },
  {
    attributeKey: 'id',
    filterOperator: 'equal_to',
    values: route.params.toolSetId,
    queryOperator: 'or',
    attributeModel: 'standard',
  },
  {
    attributeKey: 'model',
    filterOperator: 'equal_to',
    values: {
      id: 'WgptAutomation',
      name: 'WgptAutomation',
    },
    queryOperator: 'and',
    attributeModel: 'standard',
  },
  {
    attributeKey: 'id',
    filterOperator: 'equal_to',
    values: route.params.toolId,
    queryOperator: 'or',
    attributeModel: 'standard',
  },
];
</script>

<template>
  <AuditTrailSection
    :title="t('WGPT_BOTS.EDIT.TABS.TOOLS.EDITOR.SETTINGS.AUDIT_TRAIL.TITLE')"
    :description="
      t('WGPT_BOTS.EDIT.TABS.TOOLS.EDITOR.SETTINGS.AUDIT_TRAIL.DESCRIPTION')
    "
    :filters="auditTrailFilters"
  />
</template>
